import { memo, useEffect } from 'react';
import { Layer, Source, useMap } from 'react-map-gl/mapbox';
import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { TRACKING_ARROW_LAYER_STYLE, TRACKING_LAYER_STYLE } from '../../../constants/map';
import { assetLngLatsState } from '../../../storage/tracking';

function TrackingLayer() {
  const { map } = useMap();
  const { assetId } = useParams();
  const lngLats = useRecoilValue(assetLngLatsState(assetId || ''));
  const geojson: GeoJSON.Feature = {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'LineString',
      coordinates: lngLats,
    },
  };

  useEffect(() => {
    if (!map) return;
    const arrowUrl = '/img/icons/map/arrow.png';
    map.loadImage(`${arrowUrl}`, (error, image) => {
      if (error) {
        return;
      }
      if (image && !map.hasImage('arrow')) {
        map.addImage('arrow', image);
      }
    });
  }, [map]);

  return (
    <Source
      type="geojson"
      data={geojson}
      id="tracking"
    >
      <Layer {...TRACKING_LAYER_STYLE} />
      <Layer {...TRACKING_ARROW_LAYER_STYLE} />
    </Source>
  );
}

export default memo(TrackingLayer);
